var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsHeader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 589,
    height: 219,
    viewBox: "0 0 589 219",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_731_16348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.746874 247.77L241.543 247.805L250.752 247.782L589.251 268.137L579.24 178.486L360.02 217.837L563.546 124.361L511.075 68.0648L341.531 194.568L455.178 41.4311L331.11 0.843091L294.334 194.685L250.74 0.83916L132.937 27.804L250.614 202.212L79.8369 68.0437L30.5082 124.335L241.453 218.132L0.742435 178.458L0.746874 247.77Z",
    fill: "url(#paint0_radial_731_16348)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_731_16348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.5751 157.04H186C188.209 157.04 190 158.83 190 161.04V203C190 205.209 188.209 207 186 207H91.5751C87.1787 207 86.0003 200.939 90.0764 199.292L123.64 185.729C126.976 184.381 126.976 179.659 123.64 178.311L90.0764 164.748C86.0003 163.101 87.1787 157.04 91.5751 157.04Z",
    fill: "#7A4BF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.5751 155H186C188.209 155 190 156.791 190 159V200.961C190 203.17 188.209 204.961 186 204.961H91.5751C87.1787 204.961 86.0003 198.899 90.0764 197.252L123.64 183.689C126.976 182.341 126.976 177.619 123.64 176.272L90.0764 162.709C86.0003 161.062 87.1787 155 91.5751 155Z",
    fill: "url(#paint1_linear_731_16348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 203V194.64V192H161V192.44L190 203Z",
    fill: "#7A4BF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.425 157.04H404C401.791 157.04 400 158.83 400 161.04V203C400 205.209 401.791 207 404 207H498.425C502.821 207 504 200.939 499.924 199.292L466.36 185.729C463.024 184.381 463.024 179.659 466.36 178.311L499.924 164.748C504 163.101 502.821 157.04 498.425 157.04Z",
    fill: "#7A4BF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.425 155H404C401.791 155 400 156.791 400 159V200.961C400 203.17 401.791 204.961 404 204.961H498.425C502.821 204.961 504 198.899 499.924 197.252L466.36 183.689C463.024 182.341 463.024 177.619 466.36 176.272L499.924 162.709C504 161.062 502.821 155 498.425 155Z",
    fill: "url(#paint2_linear_731_16348)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 203V194.64V192H429V192.44L400 203Z",
    fill: "#7A4BF1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 145.038,
    width: 272,
    height: 51.9622,
    rx: 12,
    fill: "#B584FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 143,
    width: 272,
    height: 51.9622,
    rx: 12,
    fill: "url(#paint3_linear_731_16348)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_731_16348",
    x: 87.5703,
    y: 143,
    width: 414.859,
    height: 67,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.827451 0 0 0 0 0.847059 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_731_16348"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_731_16348",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_731_16348",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(287.88 146.481) rotate(89.8263) scale(122.405 301.024)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.81
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.09
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_731_16348",
    x1: 130.5,
    y1: 155,
    x2: 130.5,
    y2: 204.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBBCF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B689F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_731_16348",
    x1: 459.5,
    y1: 155,
    x2: 459.5,
    y2: 204.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBBCF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B689F0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_731_16348",
    x1: 295,
    y1: 143,
    x2: 295,
    y2: 194.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E3F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBBDF6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_731_16348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 589,
    height: 219,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsHeader);
export default __webpack_public_path__ + "static/media/settings-header.655b076ac05b8bbec34e5f110b32c800.svg";
export { ForwardRef as ReactComponent };